export default () => ({
  loading: false,
  initialisationPromise: null,
  isAuthenticated: false,
  user: undefined,
  error: undefined,
})
